var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVoiceChanger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 0.843,
  clipPath: "url(#voice-changer_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M5.806 3.307c0 .895-.712 1.62-1.59 1.62-.877 0-1.588-.725-1.588-1.62s.711-1.62 1.589-1.62c.877 0 1.589.725 1.589 1.62ZM4.217 6.317c-1.352 0-2.418.72-2.981 1.788-.38.721.27 1.453 1.072 1.453h3.818c.802 0 1.452-.732 1.072-1.453-.563-1.068-1.629-1.788-2.981-1.788Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M8.782 2.811a2.81 2.81 0 0 1 0 3.976m-1.325-2.65a.937.937 0 0 1 0 1.325"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "voice-changer_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h11.245v11.245H0z"
})))));
export default SvgVoiceChanger;